import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';

import * as actions from '../../actions/ticket';

import {API_URL} from '../../actions/_request';
import {api} from '../../actions/_request';
import _ from "lodash";
// styling
import './style.css';

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
       
        var pagado='';
        var pv='';
        var proceso='';
        var cliente='';
        var ticket='';
        var tecnico='';
        var fecha='';

        var take= pageSize;
        var skip=pageSize * page;
        var total=1; 
        var patt = new RegExp("(si|s)", "i"); 
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "pagado":
              
              
               patt = new RegExp("(si|s)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PAGADO---> 1');
                pagado=1;

              }else{
                patt = new RegExp("(no|n)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PAGADO---> 0');
                pagado=0;

              }else{
                patt = new RegExp("("+filtered[i].value+")", "i");
              if('credito'.search(patt)==0){
                console.log('PAGADO---> 2');
                pagado=2;
              }

              }

              }
              break;
            case "pv":
             
               patt = new RegExp("(si|s)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PV---> 1');
                pv=1;

              }else{
                patt = new RegExp("(no|n)", "i");
                if(filtered[i].value.search(patt)==0){
                  console.log('PV---> 0');
                  pv=0;
                }

              }
              break;            
            case "processName":
              patt = new RegExp("("+filtered[i].value+")", "i");
              if('inicio'.search(patt)==0){
                console.log('proceso---> 1');
                proceso=1;
              }else{
                  patt = new RegExp("("+filtered[i].value+")", "i");
                  if('proceso'.search(patt)==0){
                    console.log('proceso---> 2');
                    proceso=2;
                  }else{
                    patt = new RegExp("("+filtered[i].value+")", "i");
                    if('finalizado'.search(patt)==0){
                      console.log('proceso---> 3');
                      proceso=3;
                    }else{
                      patt = new RegExp("("+filtered[i].value+")", "i");
                      if('cancelado'.search(patt)==0){
                        console.log('proceso---> 4');
                        proceso=4;
                      }else{
                        patt = new RegExp("("+filtered[i].value+")", "i");
                        if('garantia'.search(patt)==0){
                          console.log('proceso---> 5');
                          proceso=5;
                        }
                      }

                  }
              }
            }

              break;
            case "created_at":
              fecha=filtered[i].value;
               console.log('fecha--->',filtered[i].value);
              break;
              case "cliente":
              cliente=filtered[i].value;
              console.log('cliente--->',filtered[i].value);
              break; 
              case "clave":
              ticket=filtered[i].value;
              console.log('clave--->',filtered[i].value);
              break; 
              case "asignado":
              tecnico=filtered[i].value;
              console.log('asignado--->',filtered[i].value);
              break;              
          }
        }
              
              api().get(`/tickets/busqueda?fecha=${fecha}&cliente=${cliente}&ticket=${ticket}&tecnico=${tecnico}&proceso=${proceso}&pv=${pv}&pagado=${pagado}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data.datos;
                  total= response.data.total; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
        
    });
};

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true
        };

        this.toggle = this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);

    }

    fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    this.setState({ loading: false });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
       this.props.get(res.rows);
    });
  }

    componentDidMount() {

        let self = this;
        // self.props.get_tickets();
        
    }

    toggle(evt, prospectoid = null, title = "Agregar ") {

        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
        });
    }

    render() {
const { data, pages, loading } = this.state;
        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Tickets</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            <div className="text-right">
                            

                            <ul className="list-inline mr-3 ">
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#0091ea'}} />Inicio</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#2962ff'}} />Proceso</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#00c853'}} />Finalizado</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  '#FA7052'}} />Garantía</li>
                              <li className="list-inline-item ml-2"><div className='divredondo' style={{ backgroundColor:  'red'}} />Cancelado</li>
                            </ul>

                            	<Link to="/tickets/agregar">
                                	<Button color="primary" className="mb-2" onClick={this.toggle}>
                                    	<FAplus />&nbsp;Agregar
                                	</Button>
                                </Link>
                            </div>
                            <ReactTable
                             getTrProps={(state, rowInfo, column) => {
                                 
                                  if(rowInfo === undefined){
                                         
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (e) => {
                                              this.props.history.push('/tickets/ver/'+rowInfo.original.id);
                                            }
                                        } 
                                  
                                    }
                              }}
                              
                              
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'created_at',maxWidth:100},
                                {Header: 'Tecnico', accessor: 'asignado',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {
                                    Header: 'Pagado',
                                    accessor: 'pagado',
                                     maxWidth:80,
                                    style: {paddingLeft: '5px', fontSize:'10px' },
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'SI' ? '#2962ff' : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;{row.value}
                                      </span>
                                      )
                                },
                                {   
                                    Header : 'PV' ,
                                    accessor : 'pv',
                                     maxWidth:50,
                                    style: {paddingLeft: '5px', fontSize:'10px' },
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'SI' ? '#2962ff' : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;{row.value}
                                      </span>
                                      )
                                },
                                {
                                    Header: 'Proceso',
                                    accessor: 'processName',
                                     
                                     maxWidth:100,
                                    Cell: row => {
                                        
                                        let bgcolor = '';
                                        let bgcolort = '#dadada';
                                        let w=0;

                                        switch(row.value)
                                        {
                                          case "Inicio":
                                            bgcolor = '#0091ea';  
                                            w=33;   
                                          break;
                                          case "Proceso":
                                            bgcolor = '#2962ff'; 
                                            w=67;    
                                          break;
                                          case "Finalizado":
                                            bgcolor = '#00c853';  
                                            w=100;   
                                          break;
                                          case "Cancelado":
                                            bgcolor = 'red';  
                                            w=100;   
                                          break;
                                          case "Garantina":
                                            bgcolor = '#FA7052';  
                                            w=85;   
                                          break;

                                        }

                                        // if( parseInt( row.value) > 0 && parseInt( row.value) <= 33) bgcolor = '#0091ea';
                                        // else if(parseInt( row.value) > 33 && parseInt( row.value) <= 67) bgcolor = '#2962ff';
                                        // else if(parseInt( row.value) > 85 ) bgcolor = '#00c853';
                                        // else if(parseInt( row.value) == 85) bgcolor = '#FA7052';
                                        // else bgcolort = 'red';



                                        return (
                                          <div
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              backgroundColor: `${bgcolort}`,
                                              borderRadius: '2px'
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: `${w}%`,
                                                height: '100%',
                                                backgroundColor: `${bgcolor}`,
                                                borderRadius: '2px',
                                                transition: 'all .2s ease-out'
                                              }}
                                            />
                                          </div>
                                        )
                                    }
                                },
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                              
                                                <a href={API_URL+"/ticketsv2/printRecepcion/"+row.original.id} target="_blank">
                                                    <Button color="secondary" className="btn-sm" >
                                                        <IconPrint />
                                                    </Button>
                                                </a>{' '}
                                                <Link to={`/tickets/ver/`+row.original.id}>
                                                    <Button color="secondary" className="btn-sm">
                                                        <IconOpen />
                                                    </Button>
                                                </Link>
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data      = {this.props.ticket.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                             
                              defaultPageSize={25} 
                             
                              
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Tecnicos:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Creo Ticket:</dt>
                                                <dd className="col-sm-9">{row.original.creador}</dd>

                                                 <dt className="col-sm-3 text-truncate">Tecnico Asignado</dt>
                                                <dd className="col-sm-9">{row.original.asignado}</dd>

                                                <dt className="col-sm-3 text-truncate">Cobro:</dt>
                                                <dd className="col-sm-9">{row.original.cobro}</dd>                       

                                            </dl>
                                            </div>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Cliente:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Razon Social:</dt>
                                                <dd className="col-sm-9">{row.original.empresa}</dd>

                                                 <dt className="col-sm-3 text-truncate">Telefono</dt>
                                                <dd className="col-sm-9">{row.original.telefono}</dd>

                                                <dt className="col-sm-3 text-truncate">Contacto:</dt>
                                                <dd className="col-sm-9">{row.original.contacto}</dd>                       

                                            </dl>
                                            </div>
                                              
                                            </div>




                                             <h1 className="h4 text-uppercase">Ticket:</h1>

                                              
                                                  <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha y hora</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.created_at +' '+row.original.hora}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Fecha de Pago</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.fecha_pago }}></dd>
                                                    <dt className="col-sm-3 text-truncate">Factura</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.factura}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Remision</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.remision}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripción Recepción</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Descripción Proceso/ Diagnostico</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion_proceso}}></dd>
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dt className="col-sm-3 text-truncate">Descripción de Cancelado</dt>
                                                    }
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.motivo_cancelado}}></dd>
                                                    }
                                                  </dl>
                                                  {
                                                      (row.original.proceso_id===5)&&
                                                   <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.fecha}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Tecnico de Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.usuario}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripcion Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.motivo}}></dd>
                                                   
                                                   
                                                  </dl>
                                                }
                                                

                                            


                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Iva</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>
                                                   <td>{item.subtotal_formato}</td>
                                                   <td>{item.iva_formato}</td>
                                                   <td>{item.total_formato}</td>   
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketTable)





// WEBPACK FOOTER //
// ./src/views/ticket/table.js